/*!
 * Copyright 2022 Thorne Health Lab. All rights reserved.
 */
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(theme => ({
  hoverDisable: {
    opacity: '1 !important',
    height: '40px',
    fontFamily: 'GTAM',
    fontSize: '16px',
    '& hover': {
      fontSize: '20px'
    }
  },
  redBG: {
    backgroundColor: '#e03e52',
    borderColor: '#e03e52',
    color: 'white'
  },
  marginLeft15: {
    marginLeft: '85px'
  },
  '& hr': {
    marginTop: '0px'
  }
}));

export default useStyles;
